import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'glamorous'

import Icon from 'components/common/Icon'

const ActionButton = ({ icon, size, disabled, ...rest }) => {
  return (
    <Button
      display="flex"
      alignItems="center"
      justifyContent="center"
      outline="none"
      cursor="pointer"
      background="transparent"
      width={76}
      height={76}
      padding={0}
      border={0}
      opacity={disabled ? 0.25 : 1}
      transition="opacity 70ms"
      WebkitTapHighlightColor="transparent"
      {...rest}
    >
      <Icon width={size} height={size} path={icon} />
    </Button>
  )
}

ActionButton.propTypes = {
  icon: PropTypes.node.isRequired,
  size: PropTypes.number,
  disabled: PropTypes.bool
}

ActionButton.defaultProps = {
  size: 50,
  disabled: false
}

export default ActionButton



// WEBPACK FOOTER //
// ./src/components/actions/ActionButton.js